<ng-container
  *transloco="
    let t;
    prefix: 'shared.request-walkthrough-modal.request-walkthrough-verify-phone'
  "
>
  <div class="flex flex-row justify-between">
    <h2 class="text-black text-[1.75rem]">
      {{ t("headers.main") }}
    </h2>
    <button class="p-2">
      <i class="icon-close text-black text-xl" (click)="closeDialog()"></i>
    </button>
  </div>
  <div class="divider-line1 my-6"></div>
  <div class="flex flex-col gap-6">
    <div
      class="flex flex-col gap-6 h-[600px] justify-between items-center"
      [formGroup]="form"
    >
      <div class="flex flex-col gap-4 w-full">
        <p>
          {{ t("infoText.otp-1") }} {{ phoneNumber }}. {{ t("infoText.otp-2") }}
        </p>
        <div
          class="flex flex-row items-center justify-center gap-4 max-w-[593px] w-full"
          toptCursorMove
        >
          <!-- 6 digit totp input -->
          <input 
            formControlName="digit1"
            type="text"
            class="w-10 h-10 md:w-14 md:h-12 text-center md:text-3xl bg-white rounded border border-tone-05 py-3 md:px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none"
            maxlength="1"
          />
          <input
            formControlName="digit2"
            type="text"
            class="w-10 h-10 md:w-14 md:h-12 text-center md:text-3xl bg-white rounded border border-tone-05 py-3 md:px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none"
            maxlength="1"
          />
          <input
            formControlName="digit3"
            type="text"
            class="w-10 h-10 md:w-14 md:h-12 text-center md:text-3xl bg-white rounded border border-tone-05 py-3 md:px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none"
            maxlength="1"
          />
          <input
            formControlName="digit4"
            type="text"
            class="w-10 h-10 md:w-14 md:h-12 text-center md:text-3xl bg-white rounded border border-tone-05 py-3 md:px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none"
            maxlength="1"
          />
          <input
            formControlName="digit5"
            type="text"
            class="w-10 h-10 md:w-14 md:h-12 text-center md:text-3xl bg-white rounded border border-tone-05 py-3 md:px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none"
            maxlength="1"
          />
          <input
            formControlName="digit6"
            type="text"
            class="w-10 h-10 md:w-14 md:h-12 text-center md:text-3xl bg-white rounded border border-tone-05 py-3 md:px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none"
            maxlength="1"
          />
        </div>

        @if (error) {
          <span class="text-sm text-red disabled:text-tone-06">{{
            error
          }}</span>
        }
      </div>

      <div class="flex flex-col gap-6">
        <div class="flex flex-col items-center text-black gap-2">
          <div>{{ t("headers.codeNotReceived") }}</div>
          <button
            [disabled]="((otpResendTimeRemaining$ | async) || 0) > 0"
            class="btn-text underline"
            (click)="sendTotp()"
          >
            {{ t("buttons.sendOtp") }}
            <span *ngIf="((otpResendTimeRemaining$ | async) || 0) > 0">{{
              otpResendTimeRemaining$ | async | date: "mm:ss"
            }}</span>
          </button>
          <button class="btn-text underline" (click)="resetForm()">
            {{ t("buttons.resetForm") }}
          </button>
        </div>
        <div class="divider-line1"></div>
        <button
          role="button"
          [disabled]="form.invalid"
          (click)="verifyTotp()"
          class="btn-primary w-full disabled:border-gray-200 flex flex-row items-center justify-center"
        >
          {{ t("buttons.verifyOtp") }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
